import { WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL, WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE, WIDTH_TO_HEIGHT_RATIO_DEFAULT_LANDSCAPE, WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT, } from '../../DeviationViews/constants';
// Make massive images smaller, if the image is massive in ratio
// we simply crop it to 16/9, this creates a "fair" showing look
export var applyMassiveThumbThreshold = function (item) {
    var whRatio = item.width / item.height;
    // too tall
    if (whRatio < WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL) {
        item.height = item.width / WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT;
    }
    // too wide
    if (whRatio > WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE) {
        item.width = item.height * WIDTH_TO_HEIGHT_RATIO_DEFAULT_LANDSCAPE;
    }
    return item;
};
export var applyTinyThumbThreshold = function (item, targetHeight) {
    var tinyThumbWidthThreshold = targetHeight * WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT;
    var tinyThumbHeightThreshold = targetHeight;
    item.width = Math.max(tinyThumbWidthThreshold, item.width);
    item.height = Math.max(tinyThumbHeightThreshold, item.height);
    return item;
};
export function getRowSize(layoutConfig, isMobile, useCardLayout) {
    if (useCardLayout) {
        return isMobile
            ? layoutConfig.rowSizeCardMobile
            : layoutConfig.rowSizeCardDesktop;
    }
    return isMobile ? layoutConfig.rowSizeMobile : layoutConfig.rowSizeDesktop;
}
export function getItemSpacing(layoutConfig, isMobile, useCardLayout) {
    if (layoutConfig.itemSpacingDesktop === 0 ||
        layoutConfig.itemSpacingMobile === 0) {
        return 0;
    }
    if (useCardLayout) {
        return isMobile
            ? (layoutConfig.itemSpacingCardMobile || 8) / 2
            : (layoutConfig.itemSpacingCardDesktop || 16) / 2;
    }
    return isMobile
        ? (layoutConfig.itemSpacingMobile || 8) / 2
        : (layoutConfig.itemSpacingDesktop || 16) / 2;
}
export var didItemsChange = function (itemsA, itemsB) {
    if (itemsA && itemsA.length !== itemsB.length) {
        return true;
    }
    var total = (itemsA && itemsA.length) || 0;
    for (var i = 0; i < total; i++) {
        if (itemsA[i].id !== itemsB[i].id ||
            itemsA[i].width !== itemsB[i].width ||
            itemsA[i].height !== itemsB[i].height) {
            return true;
        }
    }
    return false;
};
export var propsItemsOrContainerHasChanged = function (nextProps, prevProps) {
    if (!prevProps || !prevProps.container || !nextProps) {
        return true;
    }
    var _a = nextProps.items, nextItems = _a === void 0 ? [] : _a, nextContainerWidth = nextProps.container.width;
    var _b = prevProps.items, prevItems = _b === void 0 ? [] : _b, prevContainerWidth = prevProps.container.width;
    var dimChanged = prevContainerWidth !== nextContainerWidth;
    var itemChanged = didItemsChange(prevItems, nextItems);
    if (dimChanged || itemChanged) {
        return true;
    }
    return false;
};
//# sourceMappingURL=helpers.js.map